import React from 'react';
import { MapPin } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import ContactStrip from '../components/ContactStrip';
import SEO from '../components/SEO';
import { getSeo, SEO_KEYWORDS } from '../data/seo';
import { ASSETS } from '../data/site';

const images = [ASSETS.concreteArch1, ASSETS.labTest2, ASSETS.viennaHero, ASSETS.concreteArch2];

const CaseStudies = () => {
  const { t, lang } = useLang();
  const list = t('cases.list');
  const seo = getSeo('cases', lang);

  return (
    <div>
      <SEO title={seo.title} description={seo.description} path="/case-studies" lang={lang} keywords={SEO_KEYWORDS[lang]} />
      <PageHeader label={t('cases.label')} title={t('cases.title')} lead={t('cases.lead')} imageKey="labTest1" />
      <section className="bg-slate-50 py-16 lg:py-24">
        <div className="container-wide grid grid-cols-1 md:grid-cols-2 gap-6">
          {list.map((c, i) => (
            <Reveal key={i} delay={(i % 2) * 90}>
              <article className="group h-full flex flex-col rounded-xl bg-white border border-slate-200 overflow-hidden hover:border-blue-300 hover:shadow-md hover:shadow-blue-700/5 transition">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={images[i % images.length]}
                    alt={c.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent" />
                </div>
                <div className="p-6 lg:p-7">
                  <div className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-blue-700">
                    <MapPin className="w-3.5 h-3.5" />
                    {c.location}
                  </div>
                  <h3 className="mt-2 text-lg font-bold text-slate-900 leading-snug">{c.title}</h3>
                  <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{c.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <ContactStrip />
    </div>
  );
};

export default CaseStudies;
